var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-head'),_c('div',{staticClass:"nes minH"},[_c('h1',{staticClass:"title flex-center"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})]),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }